export default "__VITE_ASSET__CkbUROAD__"